import { inGamecenter } from '@vkplay/shared';
import { changeCookieLanguage, isReadMode } from '../../utils/services';

export default {
  name: 'AppHeader',

  data() {
    return {
      supported_langs: ['ru_RU', 'en_US'],
    };
  },

  methods: {
    initHeader() {
      if (!isReadMode && !document.getElementById('navHeader') && !inGamecenter) {
        window.EVA.init('shell', {
          simplified: true,
          footerSelector: '#shell-footer',
          hiddenElements: ['terms'],
          onGetUser: (user) => {
            const lang = user.locale;

            changeCookieLanguage(lang);
            this.$root.$i18n.locale = lang;
          },
        });
      }
    },
  },

  mounted() {
    this.initHeader();
  },
};
